import { get, post, put, del } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';
import {
  parseDataForDisplay,
  parseDataForList,
} from 'lib/NewQueryByMultimarket';

export const actions = {
  fetchAll: get`promos/`(parseDataForList),
  fetch: get`promos/:id`(parseDataForDisplay),
  update: put`promos/:id`(),
  remove: del`promos/:id`(),
  create: post`promos/`(),
};

export const reducer = createReducer(actions);
